"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Flex = _interopRequireDefault(require("../../../../../Flex"));

var _Text = _interopRequireDefault(require("../../../../../Text"));

var _useTranslation = _interopRequireDefault(require("../../../../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var formatHours = function formatHours(date) {
  return date.format('HH');
};

var formatMinutes = function formatMinutes(date) {
  var minutes = date.format('mm');
  return minutes === '00' ? '' : minutes;
};

var formatDate = function formatDate(date) {
  var dateMoment = (0, _moment["default"])(date, 'HH:mm:ss');

  if (!date || !dateMoment.isValid()) {
    return [];
  }

  return [formatHours(dateMoment), formatMinutes(dateMoment)];
};

var Cycle = function Cycle(props) {
  var start = props.start,
      end = props.end,
      other = (0, _objectWithoutProperties2["default"])(props, ["start", "end"]);
  var t = (0, _useTranslation["default"])();
  var startDate = (0, _react.useMemo)(function () {
    return formatDate(start);
  }, [start]);
  var endDate = (0, _react.useMemo)(function () {
    return formatDate(end);
  }, [end]);

  if (!startDate.length || !endDate.length) {
    return null;
  }

  return (0, _core.jsx)(_Flex["default"], other, (0, _core.jsx)(_Text["default"], null, t('from_{startHours}{startMinutes}_to_{endHours}{endMinutes}', {
    startHours: startDate[0],
    startMinutes: startDate[1],
    endHours: endDate[0],
    endMinutes: endDate[1]
  })));
};

__signature__(Cycle, "useTranslation{t}\nuseMemo{startDate}\nuseMemo{endDate}", function () {
  return [_useTranslation["default"]];
});

var _default = Cycle;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatHours, "formatHours", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Cycle.tsx");
  reactHotLoader.register(formatMinutes, "formatMinutes", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Cycle.tsx");
  reactHotLoader.register(formatDate, "formatDate", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Cycle.tsx");
  reactHotLoader.register(Cycle, "Cycle", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Cycle.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Cycle.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();